<div class="alert alert-info" ng-if="wctrl.empty">
  <p>Não há dados para serem exibidos.</p>
</div>
<p class="history-day text-cinza text-center" ng-show="wctrl.loading">
  <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
</p>
<div class="alert alert-danger" ng-if="wctrl.error">
  <p>Falha ao obter dados.</p>
</div>
<div class="weather-dashboard-list" ng-class="wctrl.widgetClasses" ng-if="!wctrl.empty && !wctrl.loading && !wctrl.error">
  <p class="update-date">
    Atualizado em {{wctrl.data.lastDate}}
  </p>
  <div class="item temperature">
    <img src="images/weather-icons/temperature.svg" class="icon">
    <p class="title">Temperatura</p>
    <p class="value">{{wctrl.data.temperature}} ºC</p>
  </div>
  <div class="item rain">
    <img src="images/weather-icons/rain.svg" class="icon">
    <p class="title">Chuva</p>
    <p class="value">{{wctrl.data.rain | number: 2}} mm</p>
  </div>
  <div class="item humidity">
    <img src="images/weather-icons/humidity.svg" class="icon">
    <p class="title">Umidade</p>
    <p class="value">{{wctrl.data.humidity}} %</p>
  </div>
  <div class="item wind">
    <img src="images/weather-icons/wind.svg" class="icon">
    <p class="title">Vento</p>
    <p class="value">{{wctrl.data.wind}} km/h</p>
  </div>
  <div class="item pressure">
    <img src="images/weather-icons/pressure.svg" class="icon">
    <p class="title">Pressão</p>
    <p class="value">{{wctrl.data.pressure}} hPa</p>
  </div>
</div>
